import {
  REQUEST_CAMPAIGN_CATEGORY_PARENT_LIST,
  REQUEST_CAMPAIGN_CATEGORY_LIST,
  REQUEST_CAMPAIGN_CATEGORY_LIST_FOR_CREATE,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCampaignCategoryParentList({commit}) {
    return axiosInst.springAxiosInst.get('/admin/campaign-category/category-parent-list')
    .then((res) => {
      commit(REQUEST_CAMPAIGN_CATEGORY_PARENT_LIST, res.data)
    })
  },

  requestCampaignCategoryList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get('/admin/campaign-category/category-list',{
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_CATEGORY_LIST, res.data)
    })
  },

  requestCreateCampaignCategory({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/campaign-category/create-category', payload)
    .then((res) => {
      return res.data
    })
  },

  async requestDeleteCampaignCategories({ commit }, payload) {
      try {
          await axiosInst.springAxiosInst.delete('/admin/campaign-category/delete-categories', { data: payload });

          return true;
      } catch (error) {
          if (error.response && error.response.data) {
              alert(error.response.data);
          } else {
              alert('삭제 중 오류가 발생했습니다.');
          }

          return false;
      }
  },

  requestCampaignCategoryListForCreate({commit}) {
    return axiosInst.springAxiosInst.get('/admin/campaign-category/get-all-categories', {
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_CATEGORY_LIST_FOR_CREATE, res.data)
    })
  },

  requestChangeCampaignCategoryActivation({}, categorySeq) {
    return axiosInst.springAxiosInst.post(`/admin/campaign-category/change-category-activation/${categorySeq}`)
    .then((res) => {
      return res.data
    })
  },
}